import styled from '@emotion/styled';
import * as React from 'react';
import SignInFooter from '../../components/organisms/Footer';
import Logo from '../../components/organisms/Logo';
import TermsContent from '../../components/organisms/TermsContent';
import { useUpdateDocumentTitle } from '../../libs/hooks/index';

const Template = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.Terms', appHeader: '', href: '' });

  return (
    <Wrapper>
      <LogoWrapper>
        <Logo href={'/'} width="185px" />
      </LogoWrapper>
      <TermsContent />
      <SignInFooter />
    </Wrapper>
  );
};

const LogoWrapper = styled.div`
  width: 856px;
  margin: 24px 0;
`;

const Wrapper = styled.div`
  width: 100%;
  min-height: 100%;
  background-color: #27313b;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 85px;
`;

export default Template;
